<template>
  <div>
    <q-form ref="editForm">
      <!-- 수급업체 상세 -->
      <c-card title="LBL0003032" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <!-- 접속ID 변경 -->
            <c-btn v-if="editable && parentVendorCd" label="LBL0003033" icon="verified_user" @btnClicked="changePortalId" />
            <!-- 비밀번호초기화 -->
            <c-btn
              v-if="editable && parentVendorCd"
              :url="resetUrl"
              :isSubmit="isReset"
              :param="data"
              mappingType="PUT"
              label="LBL0003034"
              icon="password"
              @beforeAction="resetPwd"
              @btnCallback="resetPwdCallback" />
            <!-- 등록 -->
            <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="addVendor" />
            <!-- 저장 -->
            <c-btn
              v-if="editable"
              :disabled="!saveable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="data"
              :mappingType="saveType"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveData"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-4">
            <!-- 업체 -->
            <c-text
              :required="true"
              :editable="editable && dataeditable"
              label="LBL0003030"
              name="vendorName"
              v-model="data.vendorName">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 업체코드 -->
            <c-text
              :required="true"
              :editable="editable && !updateMode && dataeditable"
              label="LBL0003035"
              name="vendorCd"
              v-model="data.vendorCd">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 사업자번호 -->
            <c-text
              :required="true"
              :editable="editable && dataeditable"
              label="LBL0003036"
              name="bizNo"
              mask="###-##-#####"
              v-model="data.bizNo"
              @dataChange="(value) => { data.portalId = $_.replace(value, /-/g, '') }">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 업체분류 -->
            <c-select
              codeGroupCd="VENDOR_CLASS_CD"
              :required="true"
              :editable="editable && dataeditable"
              type="edit"
              itemText="codeName"
              itemValue="code"
              name="vendorClassCd"
              label="LBL0003027"
              v-model="data.vendorClassCd"
            ></c-select>
          </div>
          <div class="col-4">
            <!-- 업체유형 -->
            <c-select
              codeGroupCd="VENDOR_TYPE_CD"
              :required="true"
              :editable="editable && dataeditable"
              type="edit"
              itemText="codeName"
              itemValue="code"
              name="vendorTypeCd"
              label="LBL0003028"
              v-model="data.vendorTypeCd"
            ></c-select>
          </div>
          <div class="col-4">
            <!-- 대표자명 -->
            <c-text
              :editable="editable && dataeditable"
              label="LBL0003037"
              name="representName"
              v-model="data.representName">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 대표전화번호 -->
            <c-text
              :editable="editable && dataeditable"
              :phoneNumberCheck="true"
              label="LBL0003038"
              name="phoneNo"
              v-model="data.phoneNo">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 대표이메일 -->
            <c-text
              :editable="editable && dataeditable"
              label="LBL0003039"
              name="email"
              v-model="data.email">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 담당자명 -->
            <c-text
              :editable="editable && dataeditable"
              label="LBL0003040"
              name="chargeName"
              v-model="data.chargeName">
            </c-text>
          </div>
          <div class="col-8">
            <!-- 본사주소 -->
            <c-text
              :editable="editable && dataeditable"
              label="LBL0003041"
              name="address"
              v-model="data.address">
            </c-text>
          </div>
          <div class="col-4">
            <!-- 사용여부 -->
            <c-checkbox
              :editable="editable && dataeditable"
              :isFlag="true"
              label="LBLUSEFLAG"
              name="useFlag"
              v-model="data.useFlag"
            />
          </div>
          <div class="col-12">
            <!-- 관련사업장 -->
            <c-multi-select
              :required="true"
              :editable="editable && dataeditable"
              :isArray="false"
              codeGroupCd="PLANT_CD"
              itemText="codeName"
              itemValue="code"
              label="LBL0003031"
              name="plantCds"
              v-model="data.plantCds">
            </c-multi-select>
          </div>
        </template>
      </c-card>
      <!-- 수급업체 포털정보 -->
      <c-card title="LBL0003042" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-6">
            <!-- 수급업체 포털 접속여부 -->
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="LBL0003043"
              name="portalConnFlag"
              v-model="data.portalConnFlag"
            />
          </div>
          <div class="col-6">
            <!-- 접속 ID -->
            <c-text
              readonly
              :editable="editable"
              label="LBL0003044"
              name="portalId"
              v-model="data.portalId">
            </c-text>
          </div>
        </template>
      </c-card>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'vendor-detail',
  props: {
    parentVendorCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      data: {
        vendorCd: '',  // 업체코드
        vendorName: '',  // 업체명
        vendorClassCd: null,  // 업체분류 코드
        vendorTypeCd: null,  // 업체유형 코드
        address: '',  // 본사주소
        bizNo: '',  // 사업자번호
        chargeDeptCd: '',  // 담당부서 코드
        phoneNo: '',  // 대표 전화번호
        email: '',  // 대표 이메일
        chargeName: '',  // 담당자명
        representName: '',  // 대표자명
        portalConnFlag: 'Y',  // 협력업체포탈 접속 여부
        portalId: '',  // 포탈 ID
        plantCds: '',  // 관련사업장
        plantCdArray: [],
        useFlag: 'Y',  // 사용여부
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        vendorUser: '',
      },
      resetUrl: '',
      listUrl: '',
      detailUrl: '',
      checkUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      saveable: false,
      deleteable: false,
      editable: true,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      isReset: false,
      saveUrl: transactionConfig.mdm.cim.vendor.insert.url,
      saveType: 'POST',
      searchUrl: '',
      selectedVendorCd: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
    parentVendorCd() {
      if (this.parentVendorCd) {
        this.rowClick({ vendorCd: this.parentVendorCd })
      } else {
        this.addVendor();
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.detailUrl = selectConfig.mdm.cim.vendor.get.url;
      this.checkUrl = selectConfig.mdm.cim.vendor.check.url;
      this.insertUrl = transactionConfig.mdm.cim.vendor.insert.url;
      this.updateUrl = transactionConfig.mdm.cim.vendor.update.url;
      this.deleteUrl = transactionConfig.mdm.cim.vendor.delete.url;
      this.resetUrl = transactionConfig.mdm.cim.vendor.reset.url;
    },
    changePortalId() {
      this.popupOptions.title = 'LBL0003045'; // 협력업체 Portal 아이디 변경
      this.popupOptions.param = {
        vendorCd: this.parentVendorCd,
        loginId: this.data.portalId,
      }
      this.popupOptions.target = () => import(`${'./portalIdChange.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(_portalId) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (_portalId.portalId !== undefined) {
        this.data.portalId = _portalId.portalId.data;
      }
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.rowNotSelected = false;
      this.updateMode = true;
      this.selectedVendorCd = row.vendorCd;
      this.$http.url = this.$format(this.detailUrl, this.selectedVendorCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
        this.dataeditable = true;
      },
      () => {
      });
    },
    addVendor() {
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        vendorCd: '',  // 업체코드
        vendorName: '',  // 업체명
        vendorClassCd: null,  // 업체분류 코드
        vendorTypeCd: null,  // 업체유형 코드
        address: '',  // 본사주소
        bizNo: '',  // 사업자번호
        chargeDeptCd: '',  // 담당부서 코드
        phoneNo: '',  // 대표 전화번호
        email: '',  // 대표 이메일
        chargeName: '',  // 담당자명
        representName: '',  // 대표자명
        portalConnFlag: 'Y',  // 협력업체포탈 접속 여부
        portalId: '',  // 포탈 ID
        plantCds: '',  // 관련사업장
        useFlag: 'Y',  // 사용여부
      };
      this.$emit('isNew');
    },
    reset() {
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        vendorCd: '',  // 업체코드
        vendorName: '',  // 업체명
        vendorClassCd: null,  // 업체분류 코드
        vendorTypeCd: null,  // 업체유형 코드
        address: '',  // 본사주소
        bizNo: '',  // 사업자번호
        chargeDeptCd: '',  // 담당부서 코드
        phoneNo: '',  // 대표 전화번호
        email: '',  // 대표 이메일
        chargeName: '',  // 담당자명
        representName: '',  // 대표자명
        portalConnFlag: 'Y',  // 협력업체포탈 접속 여부
        portalId: '',  // 포탈 ID
        plantCds: '',  // 관련사업장
        useFlag: 'Y',  // 사용여부
      };
      this.$emit('isNew');
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          this.$http.url = this.$format(this.checkUrl, this.data.vendorCd);
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            if (this.updateMode || _result.data === 0) {
              // 사업장 string 을 배열에 담아 전달
              if (this.data.plantCds) {
                const splitPlant = String(this.data.plantCds).split(',');
                this.data.plantCdArray = splitPlant.map(cd => ({
                  vendorCd: this.data.vendorCd,
                  plantCd: cd
                }));
              }

              window.getApp.$emit('CONFIRM', {
                title: 'LBLCONFIRM',
                message: 'MSGSAVE', // 저장하시겠습니까?
                // TODO : 필요시 추가하세요.
                type: 'info', // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.data.regUserId = this.$store.getters.user.userId
                  this.data.chgUserId = this.$store.getters.user.userId
                  this.isSave = !this.isSave;
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            } else {
              window.getApp.$emit('ALERT', {
                title: 'LBLGUIDE', // 안내
                message:
                'MSG0000952', // 동일한 업체코드가 존재합니다.
                type: 'warning', // success / info / warning / error
              });
              return;
            }
          },);
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    resetPwd() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSG0000953', // 비밀번호를 초기화 하시겠습니까?
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.chgUserId = this.$store.getters.user.userId
          this.isReset = !this.isReset;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.vendorCd);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isSave = !this.isSave;
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('searchDetail');
      if (this.saveType == 'POST') {
        this.reset();
        this.selectedVendorCd = '';
      }
    },
    resetPwdCallback() {
      window.getApp.$emit('ALERT', {
        title: 'LBLGUIDE', // 안내
        message:
        'MSG0000954', // 초기비밀번호(환경설정값)로 초기화 되었습니다.
        type: 'success', // success / info / warning / error
      });
    },
    deleteCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('searchDetail');
      this.reset();
      this.selectedVendorCd = '';
    },
  }
};
</script>
